<template>
  <div class="admin-content">
    <div class="content-main">
      <div class="main-filters">
        <div class="filter-list">
          <div class="filter-item">
            <span class="title">Email:</span>
            <el-input class="content" placeholder="Search by email" v-model="filter.email" size="small" clearable @change="changeFilter"></el-input>
          </div>
        </div>
        <div class="filter-actions">
          <el-button class="el-btn-blue" size="small" @click="changeFilter">Search</el-button>
          <el-button class="action-reset" size="small" @click="resetFilter">Reset</el-button>
        </div>
      </div>
      <div class="main-actions">
        <el-button class="el-btn-blue" size="small" icon="el-icon-plus" @click="newInvitation()">Send Invitation</el-button>
      </div>
      <div class="main-table">
        <el-table :data="invitations" v-loading="flagLoading.getInvitations" border>
          <el-table-column type="index" label="#" :index="generateIndex" width="100" />
          <el-table-column prop="email" label="Email" />
          <el-table-column prop="brand_name" label="Brand" />
          <el-table-column label="Invitation at">
            <template #default="scope">
              <span>{{ generateTime(scope.row.created_at) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Operate">
            <template #default="scope">
              <div class="table-operate">
                <div class="operate-item">
                  <el-button size="small" type="text" class="el-btn-blue" @click="showModalCopy(scope.row)">Copy Link</el-button>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="common-pagination" background layout="prev, pager, next"
          :current-page="pageNum" :page-size="pageSize" :total="totalNum"
          @current-change="changeCurrentPage"
        />
      </div>
    </div>
    <ModalInvitation
      v-bind:flagVisible="flagVisible.modalInvitation" v-on:closeModal="flagVisible.modalInvitation = false"
      v-bind:actionItem="actionItems.invitation" v-on:reloadData="reloadData"
    />
    <ModalCopyLink
      v-bind:flagVisible="flagVisible.modalCopyLink" v-on:closeModal="flagVisible.modalCopyLink = false"
      v-bind:link="actionItems.copyLink"
    />
  </div>
</template>

<script>
import { reactive } from 'vue'
import moment from 'moment'
import ModalInvitation from './modals/Invitation.vue'
import ModalCopyLink from './modals/CopyLink.vue'
import config from '@/config/index.js'
export default {
  name: 'GlobalInvitations',
  components: {
    ModalInvitation,
    ModalCopyLink
  },
  data () {
    const filter = reactive({
      name: ''
    })
    const flagLoading = reactive({
      getInvitations: false
    })
    const flagVisible = reactive({
      modalInvitation: false,
      modalCopyLink: false
    })
    const actionItems = reactive({
      invitation: {
        _id: '',
        email: '',
        brandId: ''
      },
      copyLink: ''
    })
    return {
      invitations: [],
      pageNum: 1,
      pageSize: 20,
      totalNum: 0,
      filter,
      flagLoading,
      flagVisible,
      actionItems
    }
  },
  created: function () {
    this.getInvitations()
  },
  mounted () {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    getInvitations: function () {
      this.flagLoading.getInvitations = true
      const { pageNum, pageSize, filter } = this
      let url = `/api/v1/atk_player/admin/invitations?page_num=${pageNum}&page_size=${pageSize}`
      if (filter.email) url += `&email=${encodeURIComponent(filter.email)}`
      const that = this
      this.$service.get(url).then(function (res) {
        if (res.code === 200) {
          that.invitations = res.data.list
          that.totalNum = res.data.total_num
        }
        that.flagLoading.getInvitations = false
      }).catch(function (err) {
        console.error('getInvitations', err)
        that.flagLoading.getInvitations = false
      })
    },
    generateTime: function (time) {
      const tz = moment().utcOffset()
      return moment(time).utcOffset(tz).format('D MMM YYYY HH:mm')
    },
    changeCurrentPage: function (page) {
      this.pageNum = page
      this.getInvitations()
    },
    changeFilter: function () {
      this.pageNum = 1
      this.getInvitations()
    },
    resetFilter: function () {
      this.filter = { name: '' }
      this.pageNum = 1
      this.getInvitations()
    },
    generateIndex: function (index) {
      const { pageNum, pageSize } = this
      return index + 1 + pageSize * (pageNum - 1)
    },
    newInvitation: function () {
      const actionInvitation = this.actionItems.invitation
      if (actionInvitation._id) {
        this.actionItems.invitation = {
          _id: '',
          name: ''
        }
      }
      this.flagVisible.modalInvitation = true
    },
    reloadData: function () {
      this.actionItems.invitation = {
        _id: '',
        name: '',
        brandId: ''
      }
      this.getInvitations()
    },
    showModalCopy: function (invitation) {
      this.actionItems.copyLink = `${config.baseUrl}/invitations/${invitation.uuid}`
      this.flagVisible.modalCopyLink = true
    }
  }
}
</script>
